import { NgModule } from '@angular/core';
// TODO:Spartacus - // TODO:Spartacus - Variable checkoutB2BTranslations has been removed and is no longer part of the public API. 
import { checkoutB2BTranslationChunksConfig, checkoutB2BTranslationsCs } from "@spartacus/checkout/b2b/assets";
import { CheckoutB2BRootModule } from "@spartacus/checkout/b2b/root";
// TODO:Spartacus - // TODO:Spartacus - Variable checkoutTranslations has been removed and is no longer part of the public API. 
import { checkoutTranslationChunksConfig, checkoutTranslationsCs } from "@spartacus/checkout/base/assets";
import { CheckoutRootModule, CHECKOUT_FEATURE } from "@spartacus/checkout/base/root";
import { CmsConfig, I18nConfig, provideConfig } from "@spartacus/core";

@NgModule({
  declarations: [],
  imports: [
    CheckoutRootModule,
    CheckoutB2BRootModule
  ],
  providers: [provideConfig(<CmsConfig>{
    featureModules: {
      [CHECKOUT_FEATURE]: {
        module: () =>
          import('./checkout-wrapper.module').then((m) => m.CheckoutWrapperModule),
      },
    }
  }),
  provideConfig(<I18nConfig>{
    i18n: {
      resources: checkoutTranslationsCs,
      chunks: checkoutTranslationChunksConfig,
    },
  }),
  provideConfig(<I18nConfig>{
    i18n: {
      resources: checkoutB2BTranslationsCs,
      chunks: checkoutB2BTranslationChunksConfig,
    },
  })
  ]
})
export class CheckoutFeatureModule { }
